export const isVersionGreater = (
  currentVersion: string,
  newVersion: string,
) => {
  const v1 = newVersion.split('.').map(Number);
  const v2 = currentVersion.split('.').map(Number);

  for (let i = 0; i < v1.length; i++) {
    if (v1[i] > v2[i]) {
      return true;
    }
    if (v1[i] < v2[i]) {
      return false;
    }
  }

  return false;
};
